var global = window

global.selectBasicIconFormat = function (state) {
    if (!state) return '';
    if (state.element) {
        var currentColor = $(state.element).data('color');
        var currentBackgroundImage = $(state.element).css('background-image');
        currentBackgroundImage = /^url\((['"]?)(.*)\1\)$/.exec(currentBackgroundImage);
        currentBackgroundImage = currentBackgroundImage ? currentBackgroundImage[2] : ""; // If matched, retrieve url, otherwise ""
    }
    else {
        currentBackgroundImage = '';
    }

    var text = (state.text != null && typeof state.text !== 'undefined') ? state.text : '';
    return '<div class="select2__option__bg" style="background-color: '+currentColor+'"></div><div class="select2__option__label"><span class="select-ico"> </span> ' + text + '</div>'; // optgroup
}

// ==================== Relook les inputs ============================================
global.initInputs = function (selector) {
    if (!selector) selector = $('body');
    else selector = $(selector);

    if (typeof Custom !== 'undefined') Custom.init(selector.find('input'));
    $(function () {
        $.fn.select2.amd.require(['select2/diacritics'], function (DIACRITICS) {
            // stripDiacritics code copied from select2
            function stripDiacritics(text) {
                // Used 'uni range + named function' from http://jsperf.com/diacritics/18
                function match(a) {
                    return DIACRITICS[a] || a;
                }

                return text.replace(/[^\u0000-\u007E]/g, match);
            }

            selector.find('select[readonly]').focus(function() {
                $(this).blur();
            });

            selector.find("select.select2").not('select[size]').not('select[readonly]').select2({
                matcher: function (params, data) {
                    var original_matcher = $.fn.select2.defaults.defaults.matcher;
                    var result = original_matcher(params, data);
                    if (result && data.children && result.children && data.children.length != result.children.length && original_matcher(params.term, data.text)) {

                        var original = stripDiacritics(data.text).toUpperCase();
                        var term = stripDiacritics(params.term).toUpperCase();

                        // Check if the text contains the term
                        if (original.indexOf(term) > -1) {
                            result.children = data.children;
                        }
                    }
                    return result;
                },
                templateResult: selectBasicIconFormat,
                templateSelection: selectBasicIconFormat,
                escapeMarkup: function(m) { return m; }
            });

            selector.find('.select2-ico .select2').change(function() {
                var component = $(this).closest('.select2-ico');
                if (component.is(":visible") || true) {

                    var output = component.find('.select2-label');
                    var img = component.find('.select2-img');
                    var color = component.find('.select2-img');
                    var select = component.find('select');
                    var options = select.find('option');
                    var option = options.filter('[value="' + $(this).val() + '"]');
                    output.text(option.data('label'));
                    img.css('background-image', 'url(' + option.data('ico') + ')');
                    output.css('background-color', option.data('color'));
                    if (option.data('label')) {
                        component.addClass('select2-ico--label')
                        output.show();
                    } else {
                        component.removeClass('select2-ico--label')
                        output.hide();
                    }
                }
            });
            selector.find('.select2-ico select.select2').change();
        });

    });

    /* Progress */
    setTimeout(function () {
        progressWidget()
    }, 500);
    progressWidget('.progress.noTransition');

    /* Tags */
    tagsWidget('.filterable-tags');

    /* Generic form */
    genericForm(selector);
    genericFormUpload(selector);

    /* Checkbox */
    initCheckbox(selector);

    /* Date */
    /*
    selector.find('.form__input--date, .field--date input').datepicker({
        showOn: 'both',
        changeMonth: true,
        changeYear: true,
        buttonImage: 'assets/images/icons/icon-calendrier.png',
        buttonImageOnly: true,
        dateFormat: 'yy-mm-dd',
        dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
    }).css('width', 'calc(100% - 30px)');
    */

    /* Copy */
    selector.find('.btn--copy').click(function (e) {
        var urlField = $('#copyField');
        if (!urlField.length) {
            urlField = $('<textarea id="copyField" style="display: none;"></textarea>')
            $('body').append(urlField);
        }
        var content = $(this).text().trim();
        if ($(this).data('copy')) content = $(this).data('copy');

        urlField.val(content);
        var clearMsg;
        if (clearMsg != null) {
            clearTimeout(clearMsg);
        }
        operation_message('Copie : ' + urlField.val());
        urlField.show();
        urlField.select();
        document.execCommand('copy');
        urlField.hide();
        e.preventDefault();
        e.stopPropagation();
    });

    /* Memory handled by inputs.behavior.memory */

    /* AJAX */
    selector.find('select').each(function() {
        var input = $(this);
        var ajaxUrl = input.data('ajax');
        var ajaxDone = input.data('ajax-done');
        if (ajaxUrl && !ajaxDone) {
            input.data('ajax-done', true);

            update = function(input, data, status) {
                if (status == 'success') {
                    newOptions = [];
                    input.html('<option></option>');
                    var lastGroup = '';
                    var optgroup = null;
                    $.each(data.data, function (key, value) {
                        var splitLabel = input.data('ajax-label').split('|');
                        var splitValue = input.data('ajax-value').split('|');
                        var splitGroup = input.data('ajax-group').split('|');
                        var splitSeparator = input.data('ajax-separator');

                        var newOption = {
                            text: this[splitLabel[0]],
                            id: this[splitValue[0]],
                            group: this[splitGroup[0]]
                        };

                        for (var i = 1, len = splitLabel.length; i < len; i++) {
                            newOption['text'] = newOption['text']+splitSeparator+this[splitLabel[i]];
                        }

                        for (var i = 1, len = splitValue.length; i < len; i++) {
                            newOption['id'] = newOption['id']+splitSeparator+this[splitValue[i]];
                        }

                        for (var i = 1, len = splitGroup.length; i < len; i++) {
                            newOption['group'] = newOption['group']+splitSeparator+this[splitGroup[i]];
                        }


                        newOptions.push(newOption);
                        if (lastGroup != newOption.group && newOption.group) {
                            optgroup = $('<optgroup label="'+newOption.group+'"></optgroup>');
                            lastGroup = newOption.group;
                            input.append(optgroup);
                        }

                        var optionHtml = '<option value="'+newOption.id+'">'+newOption.text+'</option>';
                        if (optgroup) optgroup.append(optionHtml);
                        else input.append(optionHtml);
                    });

                    if (input.hasClass('select2')) {
                        input.empty().select2({
                            data: newOptions
                        });
                    }

                    input.val(input.data('value')).change();
                }
            };

            // define function
            var reload = function(input) {
                requireInputs = ajaxUrl.match(/(\{{2}[A-Za-z_]+\}{2})+/g);
                var url = ajaxUrl;
                var makeCall = true;
                $.each(requireInputs, function() {
                    var replaceVar = this
                    var replaceInput = this.replace('{{', '').replace('}}', '').replace('ROW', input.closest('.form__row').data('id'))
                    var replaceInputEl = $('#'+replaceInput);
                    var replaceOut = replaceInputEl.val();
                    url = url.replace(replaceVar, replaceOut);
                    if (replaceOut == '') makeCall = false;
                });
                if (makeCall) {
                    input.addClass('field--loading');
                    callAPI(
                        'GET',
                        url,
                        {},
                        function (data, status) {
                            input.removeClass('field--loading');
                            update(input, data, status);
                        }
                    );
                }
                else {
                    input.removeClass('field--loading');
                    update(input, {"data":{}}, 'success');
                }
            };


            // apply field action
            requireInputs = ajaxUrl.match(/(\{{2}[A-Za-z_]+\}{2})+/g);
            $.each(requireInputs, function() {
                replaceInput = this.replace('{{', '').replace('}}', '').replace('ROW', input.closest('.form__row').data('id'))
                $('#'+replaceInput).change(function() {
                    reload(input);
                });
            });
            reload(input);
        }
    });
}

global.initCheckbox = function (selector) {
    $(selector).find("input[type='checkbox']").each(function() {
        var container = $(this).parent();
        if (!container.hasClass('input--checkbox')) {
            container.addClass('input--checkbox');
            $(this).after('<span class="checkmark"></span>');
        }
    });

    $(selector).find("input[type='radio']").each(function() {
        var container = $(this).parent();
        if (!container.hasClass('input--radio')) {
            container.addClass('input--radio');
            $(this).after('<span class="checkmark"></span>');
        }
    });
}

String.prototype.removeDiacritics = function () {
    var diacritics = [
        [/[\300-\306]/g, 'A'],
        [/[\340-\346]/g, 'a'],
        [/[\310-\313]/g, 'E'],
        [/[\350-\353]/g, 'e'],
        [/[\314-\317]/g, 'I'],
        [/[\354-\357]/g, 'i'],
        [/[\322-\330]/g, 'O'],
        [/[\362-\370]/g, 'o'],
        [/[\331-\334]/g, 'U'],
        [/[\371-\374]/g, 'u'],
        [/[\321]/g, 'N'],
        [/[\361]/g, 'n'],
        [/[\307]/g, 'C'],
        [/[\347]/g, 'c'],
    ];
    var s = this;
    for (var i = 0; i < diacritics.length; i++) {
        s = s.replace(diacritics[i][0], diacritics[i][1]);
    }
    return s;
}
Object.size = function (obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};
String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};


global.quickSearchSimple = function (selectSrc, selectDest, search, selected, enableEmpty) {
    var pertinanceKeywords = ['Résultats les plus pertinants', 'Résultats pertinants', 'Pertinance négligeable', 'Un possible lien', 'Peu pertinant', 'Probablement aucun rapport', 'Définitivement aucun rapport', 'Combien de mots contient votre recherche déjà ?', 'Si vous voyez ce message, vous méritez un diplôme pour vos recherches complexes']
    var pertinanceKey = 0;
    var searchRaw = search.toLowerCase().removeDiacritics().replaceAll('.', '').split(' ');
    var search = [];
    var ignoredWords = ['de', 'a', 'des', 'du', 'le', 'la', 'les'];
    var found = {};
    var maxMatches = 0;
    var atLeastOneTest = false;

    // words patches
    var wordsEq = [
        ['saint', ' st'],
        ['rte', 'route'],
        ['inc', 'incorpore'],
        ['lte', 'limité'],
        ['corp', 'corporation'],
        ['rta', 'rio tinto'],
        ['qc', 'quebec']
    ]
    for (var item in searchRaw) {
        var found = false;
        $.each(wordsEq, function (i, currentWordsEq) {
            if ($.inArray(searchRaw[item], currentWordsEq) != -1 || $.inArray(' ' + searchRaw[item], currentWordsEq) != -1) {
                found = true;
                search = search.concat(currentWordsEq)
            }
        });
        if (!found) search.push(searchRaw[item]);
    }
    ;

    var tagOptgroup = 'optgroup';
    if ($(selectSrc).prop("tagName") == 'UL') tagOptgroup = 'ul';

    // start process
    var found = [];
    $(selectSrc).find('option, li').each(function (index) {
        var option = $(this).text();
        var optionId = $(this).val();
        var optionTest = $(this).text().toLowerCase().removeDiacritics().replaceAll('.', '');
        if ($(this).data('search')) optionTest += ' ' + $(this).data('search').toLowerCase().removeDiacritics().replaceAll('.', '');
        var matchWords = 0;

        // match tests
        for (var item in search) {
            if ($.inArray(search[item], ignoredWords) == -1 && search[item].length > 1) {
                atLeastOneTest = true;
                if (optionTest.indexOf(search[item]) !== -1) {
                    matchWords++;
                }
            }
        }
        ;

        // if word match
        if (matchWords > 0) {
            $(this).show();
            $(this).parents('li').show();
        }
        else {
            $(this).hide();
        }
    });
}

global.quickSearch = function (selectSrc, selectDest, search, selected, enableEmpty) {
    var pertinanceKeywords = ['Résultats les plus pertinants', 'Résultats pertinants', 'Pertinance négligeable', 'Un possible lien', 'Peu pertinant', 'Probablement aucun rapport', 'Définitivement aucun rapport', 'Combien de mots contient votre recherche déjà ?', 'Si vous voyez ce message, vous méritez un diplôme pour vos recherches complexes']
    var pertinanceKey = 0;
    var searchRaw = search.toLowerCase().removeDiacritics().replaceAll('.', '').split(' ');
    var search = [];
    var ignoredWords = ['de', 'a', 'des', 'du', 'le', 'la', 'les'];
    var found = {};
    var maxMatches = 0;
    var atLeastOneTest = false;

    // words patches
    var wordsEq = [
        ['saint', ' st'],
        ['rte', 'route'],
        ['inc', 'incorpore'],
        ['lte', 'limité'],
        ['corp', 'corporation'],
        ['rta', 'rio tinto'],
        ['qc', 'quebec']
    ]
    for (var item in searchRaw) {
        var found = false;
        $.each(wordsEq, function (i, currentWordsEq) {
            if ($.inArray(searchRaw[item], currentWordsEq) != -1 || $.inArray(' ' + searchRaw[item], currentWordsEq) != -1) {
                found = true;
                search = search.concat(currentWordsEq)
            }
        });
        if (!found) search.push(searchRaw[item]);
    }
    ;

    var tagOptgroup = 'optgroup';
    if ($(selectSrc).prop("tagName") == 'UL') tagOptgroup = 'ul';

    var simple = false;
    if (!selectDest) simple = true;

    // start process
    var found = [];
    $(selectSrc).find('option, li').each(function (index) {
        var option = $(this).text();
        var optionId = $(this).val();
        var optionTest = $(this).text().toLowerCase().removeDiacritics().replaceAll('.', '');
        if ($(this).data('search')) optionTest += ' ' + $(this).data('search').toLowerCase().removeDiacritics().replaceAll('.', '');
        var matchWords = 0;

        // match tests
        for (var item in search) {
            if ($.inArray(search[item], ignoredWords) == -1 && search[item].length > 1) {
                atLeastOneTest = true;
                if (optionTest.indexOf(search[item]) !== -1) {
                    matchWords++;
                }
            }
        }
        ;

        // if word match
        if (simple) {
            if (matchWords > 0) {
                $(this).show();
                $(this).parents('li').show();
            }
            else {
                $(this).hide();
            }
        }
        else {
            if (matchWords > 0) {
                if ($(this).data('priority')) matchWords += parseInt($(this).data('priority'));
                if (!found[matchWords]) found[matchWords] = [];
                found[matchWords].push({'id': optionId, 'label': option, 'el': $(this)});
                if (matchWords > maxMatches) maxMatches = matchWords;
            }
        }
    });
    // display search results
    if (!simple) {
        if (Object.size(found) > 0) {
            selectDest.html('');

            for (var i = maxMatches; i > 0; i--) {
                if (found[i] && found[i].length > 0) {
                    var optionsGroup = $('<' + tagOptgroup + ' label="' + pertinanceKeywords[pertinanceKey] + '"></' + tagOptgroup + '>');
                    $.each(found[i], function (i, val) {
                        var option = $(val.el).clone();
                        //var option = $('<option value="'+val.id+'" style="'+val.el.attr('style')+'" '+((selected && selected == val.id)?'selected="selected"':'')+' tooltip="'+val.el.attr('tooltip')+'">'+val.label+'</option>');
                        option.css('display', 'block')
                        optionsGroup.append(option);
                    });
                    selectDest.append(optionsGroup);
                    pertinanceKey++;
                }
            }
            return true;
        }
        else {
            if (atLeastOneTest) {
                selectDest.html('<' + tagOptgroup + ' label="Aucun résultat"></' + tagOptgroup + '>');
                return true;
            }
            return false;
        }
    }
}

global.confirmSweet = function (msg, action) {
    swal({
            title: "Confirmation",
            text: msg,
            type: "warning",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Oui",
            closeOnConfirm: true
        },
        action);
}

global.tagsWidget = function (selector) {
    if ($('.filterable-val').length) {
        var currentDepartements = $('.filterable-val').val().split(',');
        $.each(currentDepartements, function () {
            $(selector).find('.tag[data-tag="' + this + '"]').addClass('active');
        });
        tagsWidgetFilter();
    }

    $(selector).find('.tag').click(function() {
        $(this).toggleClass('active');
        var currentDepartements = [];
        $(selector).find('.tag.active').each(function( index ) {
            currentDepartements.push($(this).data('id'));
        });
        $('.filterable-val').val(currentDepartements);
        tagsWidgetFilter();
    });
};

global.tagsWidgetFilter = function () {
    var filtered = $('.filterable-item');
    filtered.hide()

    var departementFilter = '';
    $('.filterable-tags .tag.active').each(function( index ) {
        var currentDep = $(this).data('tag');
        if (currentDep) departementFilter += '.tag-'+currentDep+',';
    });
    if (departementFilter) {
        filtered = filtered.filter(departementFilter.replace(/(^,)|(,$)/g, ""));
    }

    filtered.show();
}

global.selectorActiviteUpdate = function (contrat, selector) {
    ajaxCall({
        type: 'GET', // POST, PUT, DELETE, GET
        url: 'app/modules/feuilleTemps/actions/getActiviteSelect.php',
        data: {
            'contrat': contrat,
        },
        dataType: 'html',
        success: function(data) {
            var callback = $('#'+selector+'__wrap').data('callback');
            var onchange = $('#'+selector+'__wrap').data('onchange');
            var setVal = $('#'+selector).data('val');
            var attrReadonly = $('#'+selector).attr('readonly');
            $('#'+selector+'__wrap').html($(data).html());
            $('#'+selector+'__wrap .select--activite').attr('id', selector);
            if (setVal) $('#'+selector).val(setVal);
            if (attrReadonly) $('#'+selector).attr('readonly', attrReadonly);
            initInputs('#'+selector+'__wrap');
            if (callback) eval(callback);
            if (onchange) $('#'+selector).change(function() {eval(onchange);})
        },
        error: function(data) {
        },
        complete: function(data) {
            toggleLoading(0);
        }
    });
}

var newId = 1;
global.genericForm = function (selector) {
    if (!selector) selector = $('body');
    var forms = selector.find('.form--generic');

    forms.each(function() {
        var form = $(this);
        var formName = form.data('name');
        var commit = (form.data('commit') === false)?false:true;
        var grid = form.find('.form__grid');
        var rows = form.find('.form__row');
        var add = form.find('.form__add');
        var newRow = form.find('.form__row--new');
        form.data('new', newRow[0]);
        newRow.remove();

        // Ajout
        if (!add.data('done') && add.length) {
            add.data('done', true);
            add.click(function() {
                var newItem = $(form.data('new')).clone();
                var inputs = newItem.find('.form__input');
                var data = {}

                inputs.each(function() {
                    var input = $(this);
                    var inputName = input.data('name');
                    data[inputName] = input.val();
                });

                var callbackAdd = function(data) {
                    grid.prepend(newItem);
                    genericFormInitRow(newItem);
                    newItem.removeClass('form__row--new');
                    newItem.attr('data-id', (form.data('pk'))?data.data[form.data('pk')]:data.data.id);

                    if (form.data('add')) eval(form.data('add'));

                    inputs.each(function() {
                        var input = $(this);
                        if (input.val() == 'new') input.val('');
                        if (input.attr('id')) {
                            input.attr('id', input.attr('id').replace('_new', '_' + data.data.id));
                        }
                    });

                    inputs.filter('input, textarea').first().focus();

                    newItem.find('select').data('ajax-done', false);
                    initInputs(newItem);
                }

                if (commit) {
                    callAPI(
                        'POST',
                        formName,
                        data,
                        function (data) {
                            callbackAdd(data);
                        }
                    );
                }
                else {
                    callbackAdd({
                        data: {
                            'id': 'new'+newId
                        }
                    });
                    newId++;
                }
            });
        }

        rows.each(function() {
            var row = $(this);
            var inputs = row.find('.form__input');

            genericFormInitRow(row);
        })
    })
}

global.genericFormInitRow = function (row) {
    var form = row.closest('.form--generic');
    var commit = (form.data('commit') === false)?false:true;
    var formName = form.data('name');
    var onUpdate = form.data('on-update');
    var onUpdateError = form.data('on-update-error');
    var inputs = row.find('.form__input');
    var remove = row.find('.form__remove')

    // Input change
    inputs.on('focusin', function(){
        $(this).data('last', $(this).val());
    });

    inputs.change(function(event, handler) {
        var input = $(this);
        var inputName = input.data('name');
        var onFieldUpdate = input.data('on-update');
        var onFieldUpdateError = input.data('on-update-error');
        var id = row.data('id')

        if (input.hasClass('form__input--float')) {
            input.val(input.val().replace(',', '.'));
        }

        var data = {};
        data[inputName] = input.val();

        if (commit && formName) {
            row.addClass('loading');

            callAPI(
                'PUT',
                formName + '/' + id,
                data,
                function (data) {
                    row.removeClass('loading');
                    if (onUpdate) eval(onUpdate);
                    if (onFieldUpdate) eval(onFieldUpdate);
                    input.removeClass('error');
                },
                function (data) {
                    var response = JSON.parse(data.responseText)
                    if (onUpdateError) eval(onUpdateError);
                    if (onFieldUpdateError) eval(onFieldUpdateError);
                    input.val(input.data('last'));
                    input.addClass('error');
                }
            );
        }
    });

    // Remove item
    remove.click(function() {
        var input = $(this);
        var inputName = input.data('name');
        var id = row.data('id')
        row.addClass('loading');
        var data = {};

        if (commit) {
            callAPI(
                'DELETE',
                formName + '/' + id,
                data,
                function (data) {
                    row.remove();
                }
            );
        }
        else {
            row.remove();
        }
    });
}

global.genericFormUpload = function (selector) {
    if (!selector) selector = $('body');
    var forms = $(selector).find('.form--upload').addBack('.form--upload');

    $("html").on("drop", function(e) { e.preventDefault(); e.stopPropagation(); });

    forms.each(function() {
        var form = $(this);
        var formName = form.data('name');
        var formUp = form.find("." + formName + "-up");
        if (!formUp.length) formUp = $("#"+formName+"-up");

        if (form.data('uploadAdded')) return;

        form.data('uploadAdded', true);
        form.addClass('form--upload--'+formName);

        var isVectorize = function () {
            return !!(form.data('vectorize') || form.attr('data-vectorize') || formUp.data('vectorize') || formUp.find('[name="up_vectorize"]').val());
        };

        var sendUploadWithFile = function (file) {
            var fd = new FormData(formUp[0]);
            if (file) {
                fd.set('up_avatar', file, file.name);
                fd.set('avatar', file, file.name);
            }
            formUp.data('formData', fd);
            formUp.submit();
        };

        var processFileAndUpload = function (file) {
            if (!file) return;

            if (isVectorize() && typeof Potrace !== 'undefined') {
                var fileName = file.name ? file.name.toLowerCase() : '';
                var isSvg = file.type === 'image/svg+xml' || fileName.endsWith('.svg');
                if (isSvg) {
                    sendUploadWithFile(file);
                    return;
                }

                form.addClass('form--upload--loading');
                Potrace.vectorize(file)
                    .then(function (res) {
                        form.removeClass('form--upload--loading');
                        sendUploadWithFile(res.file);
                    })
                    .catch(function (err) {
                        form.removeClass('form--upload--loading');
                        console.error('Vectorization failed:', err);
                        sendUploadWithFile(file);
                    });
            } else {
                sendUploadWithFile(file);
            }
        };

        form.click(function(e) {
            if (form.data('open') && form.data('url')) {
                window.open(form.data('url'));
            }
            else {
                formUp.find('.upload').click();
            }
        })

        formUp.click(function(e) {
            e.stopPropagation();
        })

        form.on('click', '.remove', function (e) {
            e.stopPropagation();
            swal({
                title: 'Suppression du document',
                text: 'Êtes vous certain de vouloir supprimer ce document ?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ff0000',
                cancelButtonColor: '#686868',
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non',
                closeOnConfirm: true
            },
            function () {
                formUp.find('.action').val('remove');
                formUp.data('formData', null);
                $('#'+formName+'-up').submit();
            });
        });

        formUp.find(".upload").change(function () {
            var files = this.files;
            if (files && files.length > 0) {
                processFileAndUpload(files[0]);
            } else if ($(this).val()) {
                $('#'+formName+'-up').submit();
            }
        });

        form.on('dragenter', function (e) {
            e.stopPropagation();
            e.preventDefault();
            form.addClass('form--upload--drag');
        });

        // Drag over
        $('body').on('dragover', function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (!$(e.target).closest('.form--upload--'+formName).length) {
                form.removeClass('form--upload--drag');
            }
        });

        // Drop
        form.on('drop', function (e) {
            e.stopPropagation();
            e.preventDefault();
            form.removeClass('form--upload--drag');

            var files = e.originalEvent.dataTransfer.files;
            if (files && files.length > 0) {
                processFileAndUpload(files[0]);
            }
        });

        formUp.on('submit', (function (e) {
            e.preventDefault();
            form.addClass('form--upload--loading');
            ajaxCall({
                type: "POST",
                url: 'up.php',
                data: ($(this).data('formData'))?$(this).data('formData'):new FormData(this),
                dataType: "json",
                contentType: false,
                cache: false,
                processData: false,
                success: function (data) {
                    form.removeClass('form--upload--loading');
                    formUp.data('formData', null);
                    formUp.find('.upload').val('');

                    if (data && data.message) {
                        operation_message(data.message, data.result ? 'success' : 'error');
                    }

                    if (data && data.result) {
                        var action = data.action || formUp.find('.action').val();
                        if (action === 'remove') {
                            form.find('.avatar__img').css('background-image', 'none').attr('src', '');
                            form.data('url', '').attr('data-url', '');
                            form.find('.remove').remove();
                        } else if (data.url) {
                            var avatarImg = form.find('.avatar__img');
                            if (avatarImg.is('img')) {
                                avatarImg.attr('src', data.url);
                            } else {
                                avatarImg.css('background-image', 'url(' + data.url + ')').empty();
                            }
                            form.data('url', data.url).attr('data-url', data.url);

                            if (!form.find('.remove').length && form.data('enabled') !== false) {
                                form.append('<a class="icon-cross icon icon--24 remove" data-original-title="Supprimer"></a>');
                            }
                        }

                        if (typeof inputReloadParent === 'function') {
                            inputReloadParent(form);
                        }
                        form.trigger('change');
                    }
                    formUp.find('.action').val('');
                },
                error: function (data) {
                    form.removeClass('form--upload--loading');
                    formUp.data('formData', null);
                    formUp.find('.action').val('');
                    operation_message("Erreur lors de l'envoi du fichier", 'error');
                }
            });
            return false;
        }));
    })
}

global.sendFormAndReloadPage = function (target) {
    var form = $(target).closest('form');
    var formData = form.serialize();
    if ($('#page').val()) formData += '&page='+$('#page').val();
    loadPage($('#id').val(), '&'+formData);
}


global.condFieldAdd = function (fieldName, condFieldName, operator, valeur) {
    var targetField = $('[name="' + fieldName + '"]');
    var targetFieldArea = targetField.closest('.field').closest('.col');
    var condField = $('[name="' + condFieldName + '"]');

    targetFieldArea.hide();
    targetField.attr('disabled', 'disabled');
    condField.change(function () {
        var condVal = null;
        $.each($(this).closest('form').serializeArray(), function () {
            if (this.name == condFieldName) condVal = this.value;
        });

        var expression = [];
        $.each(valeur, function(val) {
            expression.push('"'+condVal+'"' + operator + '"'+this+'"');
        });

        if (eval(expression.join(' && '))) {
            targetFieldArea.show();
            targetField.removeAttr('disabled');
        }
        else {
            targetFieldArea.hide();
            targetField.attr('disabled', 'disabled');
        }
    })

    $(function() {
        condField.change();
    })
}
